import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import EmployeeDetailsCard from './components/employeeDetailsCard';
import { requestEmployee } from 'actionCreators';
import { getEmployeeById, getRole } from '../../../../reducers';
import connectUI from 'redux-ui';
import MessageBox from 'components/MessageBox';
import Loading from 'components/Loading';

class EmployeeDetails extends Component {
  componentDidMount = () => this.props.requestEmployee(this.props.id);

  componentWillUnmount = () => (this.props.ui.successMessage ? this.props.updateUI('successMessage', '') : null);

  handleTabChange = index => this.props.updateUI('activeTab', index);

  render = () => <div>
    {this.props.ui.successMessage ? <MessageBox message={this.props.ui.successMessage} /> : null}
    {!this.props.loading ? <EmployeeDetailsCard
      employee={this.props.employee}
      role={this.props.role}
      position={this.props.position}
      mvw={this.props.mvw}
      onTabChange={this.handleTabChange}
      activeTab={this.props.ui.activeTab}
    /> : <Loading />}
  </div>;
}

EmployeeDetails.propTypes = {
  requestEmployee: PropTypes.func,
  updateUI: PropTypes.func,
  employee: PropTypes.object,
  loading: PropTypes.bool,
  ui: PropTypes.object,
  role: PropTypes.string,
  position: PropTypes.string,
  mvw: PropTypes.object,
  id: PropTypes.number,
};

const mapStateToProps = (state, ownProps) => {
  const id = Number(ownProps.params.id);
  const employee = getEmployeeById(state)[id];
  return {
    id,
    employee,
    loading: employee ? employee.loading : true,
    role: getRole(state),
    position: state.user.position,
    mvw: state.user.manage_vendor_workrooms || {},
  };
};

export default connectUI()(connect(
  mapStateToProps, { requestEmployee },
)(EmployeeDetails));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/employees/employeeDetails.jsx